const AUTH_CALLBACK_PARAMS = /(?:^|&)(?:access_token|refresh_token|error_code|error_description|error)=/

/**
 * Strips a Supabase auth-callback fragment (`#access_token=...` / `#error=...`)
 * from a path or bare hash. The tokens are consumed by the auth client when the
 * page first loads; keeping the fragment in a stored redirect target (or
 * re-appending it while rewriting a route) would resurrect stale credentials
 * into the final URL. Regular anchors are kept.
 */
export function stripAuthCallbackHash(path: string) {
  const hashIndex = path.indexOf('#')
  if (hashIndex === -1) {
    return path
  }
  const hash = path.slice(hashIndex + 1)
  return AUTH_CALLBACK_PARAMS.test(hash) ? path.slice(0, hashIndex) : path
}
